import { HttpMethod } from "../common/lib/fetch/useFetch";
import useRequest, { RequestOptions } from "../common/lib/fetch/useRequest";

const useDevUnlockStagedPurchaseOrder = (stagedPurchaseOrderId: string, options?: RequestOptions) =>
  useRequest<void>({
    headers: () => Promise.resolve(new Headers()),
    method: HttpMethod.POST,
    path: `/api/developer/stagedPurchaseOrders/${stagedPurchaseOrderId}/unlock`
  }, options);

export default useDevUnlockStagedPurchaseOrder;
